<template>
  <div @click="closeSourceFilters()" class="discover-topics-apply-filter">
    <div class="discover-topics-apply-filter__tabs-container">
      <div class="discover-topics-apply-filter__tabs-container--tabs">
        <a @click="activeTabs('news-tab')" href="#active-news" class="btn" :class="{'active': activeNewsTab}">News</a>
        <a @click="activeTabs('insight-tab')" href="#active-insights" class="btn tabs-two" :class="{'active': !activeNewsTab}">Research</a>
      </div>
      <div class="discover-topics-apply-filter__tabs-container--buttons">
          <button @click.stop="openSourcesDrawer()"
              class="btn">
              <svg width="18" height="16" viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M8.00008 16C7.71675 16 7.47925 15.9042 7.28758 15.7125C7.09591 15.5208 7.00008 15.2833 7.00008 15V9L1.20008 1.6C0.95008 1.26667 0.91258 0.916667 1.08758 0.55C1.26258 0.183333 1.56675 0 2.00008 0H16.0001C16.4334 0 16.7376 0.183333 16.9126 0.55C17.0876 0.916667 17.0501 1.26667 16.8001 1.6L11.0001 9V15C11.0001 15.2833 10.9042 15.5208 10.7126 15.7125C10.5209 15.9042 10.2834 16 10.0001 16H8.00008ZM9.00008 8.3L13.9501 2H4.05008L9.00008 8.3Z" />
              </svg>
          </button>
          <div class="sort-container" @click.stop="showSortDrawer()">
              <div class="btn">
                  <img src="@/assets/icons/sort.svg" alt="icon" />
              </div>
          </div>
          <button @click.stop="showRequestSourceDrawer" class="btn">
              <img src="@/assets/icons/request-icon.svg" alt="Icon" class="request-icon" >
          </button>
      </div>
    </div>
    <div class="discover-topics-apply-filter__topics">
      <button
        :class="{ active: stateActiveTopicTab === 'Trending news' }"
        class="btn default-btn"
        @click="activeTopic()"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          src="@/assets/icons/world.svg"
          alt="icon"
        >
          <path
            d="M8.99996 17.3334C7.86107 17.3334 6.78468 17.1146 5.77079 16.6771C4.7569 16.2396 3.87149 15.6424 3.11454 14.8854C2.3576 14.1285 1.76038 13.2431 1.32288 12.2292C0.885376 11.2153 0.666626 10.1389 0.666626 9.00002C0.666626 7.84724 0.885376 6.76738 1.32288 5.76044C1.76038 4.75349 2.3576 3.87155 3.11454 3.1146C3.87149 2.35766 4.7569 1.76044 5.77079 1.32294C6.78468 0.885437 7.86107 0.666687 8.99996 0.666687C10.1527 0.666687 11.2326 0.885437 12.2395 1.32294C13.2465 1.76044 14.1284 2.35766 14.8854 3.1146C15.6423 3.87155 16.2395 4.75349 16.677 5.76044C17.1145 6.76738 17.3333 7.84724 17.3333 9.00002C17.3333 10.1389 17.1145 11.2153 16.677 12.2292C16.2395 13.2431 15.6423 14.1285 14.8854 14.8854C14.1284 15.6424 13.2465 16.2396 12.2395 16.6771C11.2326 17.1146 10.1527 17.3334 8.99996 17.3334ZM8.99996 15.625C9.36107 15.125 9.67357 14.6042 9.93746 14.0625C10.2013 13.5209 10.4166 12.9445 10.5833 12.3334H7.41663C7.58329 12.9445 7.79857 13.5209 8.06246 14.0625C8.32635 14.6042 8.63885 15.125 8.99996 15.625ZM6.83329 15.2917C6.58329 14.8334 6.36454 14.3577 6.17704 13.8646C5.98954 13.3715 5.83329 12.8611 5.70829 12.3334H3.24996C3.65274 13.0278 4.15621 13.632 4.76038 14.1459C5.36454 14.6597 6.05551 15.0417 6.83329 15.2917ZM11.1666 15.2917C11.9444 15.0417 12.6354 14.6597 13.2395 14.1459C13.8437 13.632 14.3472 13.0278 14.75 12.3334H12.2916C12.1666 12.8611 12.0104 13.3715 11.8229 13.8646C11.6354 14.3577 11.4166 14.8334 11.1666 15.2917ZM2.54163 10.6667H5.37496C5.33329 10.3889 5.30204 10.1146 5.28121 9.84377C5.26038 9.57294 5.24996 9.29169 5.24996 9.00002C5.24996 8.70835 5.26038 8.4271 5.28121 8.15627C5.30204 7.88544 5.33329 7.61113 5.37496 7.33335H2.54163C2.47218 7.61113 2.4201 7.88544 2.38538 8.15627C2.35065 8.4271 2.33329 8.70835 2.33329 9.00002C2.33329 9.29169 2.35065 9.57294 2.38538 9.84377C2.4201 10.1146 2.47218 10.3889 2.54163 10.6667ZM7.04163 10.6667H10.9583C11 10.3889 11.0312 10.1146 11.052 9.84377C11.0729 9.57294 11.0833 9.29169 11.0833 9.00002C11.0833 8.70835 11.0729 8.4271 11.052 8.15627C11.0312 7.88544 11 7.61113 10.9583 7.33335H7.04163C6.99996 7.61113 6.96871 7.88544 6.94788 8.15627C6.92704 8.4271 6.91663 8.70835 6.91663 9.00002C6.91663 9.29169 6.92704 9.57294 6.94788 9.84377C6.96871 10.1146 6.99996 10.3889 7.04163 10.6667ZM12.625 10.6667H15.4583C15.5277 10.3889 15.5798 10.1146 15.6145 9.84377C15.6493 9.57294 15.6666 9.29169 15.6666 9.00002C15.6666 8.70835 15.6493 8.4271 15.6145 8.15627C15.5798 7.88544 15.5277 7.61113 15.4583 7.33335H12.625C12.6666 7.61113 12.6979 7.88544 12.7187 8.15627C12.7395 8.4271 12.75 8.70835 12.75 9.00002C12.75 9.29169 12.7395 9.57294 12.7187 9.84377C12.6979 10.1146 12.6666 10.3889 12.625 10.6667ZM12.2916 5.66669H14.75C14.3472 4.97224 13.8437 4.36808 13.2395 3.85419C12.6354 3.3403 11.9444 2.95835 11.1666 2.70835C11.4166 3.16669 11.6354 3.64238 11.8229 4.13544C12.0104 4.62849 12.1666 5.13891 12.2916 5.66669ZM7.41663 5.66669H10.5833C10.4166 5.05558 10.2013 4.47919 9.93746 3.93752C9.67357 3.39585 9.36107 2.87502 8.99996 2.37502C8.63885 2.87502 8.32635 3.39585 8.06246 3.93752C7.79857 4.47919 7.58329 5.05558 7.41663 5.66669ZM3.24996 5.66669H5.70829C5.83329 5.13891 5.98954 4.62849 6.17704 4.13544C6.36454 3.64238 6.58329 3.16669 6.83329 2.70835C6.05551 2.95835 5.36454 3.3403 4.76038 3.85419C4.15621 4.36808 3.65274 4.97224 3.24996 5.66669Z"
          />
        </svg>
        <span>Trending</span>
      </button>
      <div class="discover-topics-apply-filter__topics--all-tabs-btn">
        <button
          :class="{ active: stateActiveTopicTab === 'Trending news' }"
          class="btn default-btn mobile-btn-default"
          @click="activeTopic()"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            src="@/assets/icons/world.svg"
            alt="icon"
          >
            <path
              d="M8.99996 17.3334C7.86107 17.3334 6.78468 17.1146 5.77079 16.6771C4.7569 16.2396 3.87149 15.6424 3.11454 14.8854C2.3576 14.1285 1.76038 13.2431 1.32288 12.2292C0.885376 11.2153 0.666626 10.1389 0.666626 9.00002C0.666626 7.84724 0.885376 6.76738 1.32288 5.76044C1.76038 4.75349 2.3576 3.87155 3.11454 3.1146C3.87149 2.35766 4.7569 1.76044 5.77079 1.32294C6.78468 0.885437 7.86107 0.666687 8.99996 0.666687C10.1527 0.666687 11.2326 0.885437 12.2395 1.32294C13.2465 1.76044 14.1284 2.35766 14.8854 3.1146C15.6423 3.87155 16.2395 4.75349 16.677 5.76044C17.1145 6.76738 17.3333 7.84724 17.3333 9.00002C17.3333 10.1389 17.1145 11.2153 16.677 12.2292C16.2395 13.2431 15.6423 14.1285 14.8854 14.8854C14.1284 15.6424 13.2465 16.2396 12.2395 16.6771C11.2326 17.1146 10.1527 17.3334 8.99996 17.3334ZM8.99996 15.625C9.36107 15.125 9.67357 14.6042 9.93746 14.0625C10.2013 13.5209 10.4166 12.9445 10.5833 12.3334H7.41663C7.58329 12.9445 7.79857 13.5209 8.06246 14.0625C8.32635 14.6042 8.63885 15.125 8.99996 15.625ZM6.83329 15.2917C6.58329 14.8334 6.36454 14.3577 6.17704 13.8646C5.98954 13.3715 5.83329 12.8611 5.70829 12.3334H3.24996C3.65274 13.0278 4.15621 13.632 4.76038 14.1459C5.36454 14.6597 6.05551 15.0417 6.83329 15.2917ZM11.1666 15.2917C11.9444 15.0417 12.6354 14.6597 13.2395 14.1459C13.8437 13.632 14.3472 13.0278 14.75 12.3334H12.2916C12.1666 12.8611 12.0104 13.3715 11.8229 13.8646C11.6354 14.3577 11.4166 14.8334 11.1666 15.2917ZM2.54163 10.6667H5.37496C5.33329 10.3889 5.30204 10.1146 5.28121 9.84377C5.26038 9.57294 5.24996 9.29169 5.24996 9.00002C5.24996 8.70835 5.26038 8.4271 5.28121 8.15627C5.30204 7.88544 5.33329 7.61113 5.37496 7.33335H2.54163C2.47218 7.61113 2.4201 7.88544 2.38538 8.15627C2.35065 8.4271 2.33329 8.70835 2.33329 9.00002C2.33329 9.29169 2.35065 9.57294 2.38538 9.84377C2.4201 10.1146 2.47218 10.3889 2.54163 10.6667ZM7.04163 10.6667H10.9583C11 10.3889 11.0312 10.1146 11.052 9.84377C11.0729 9.57294 11.0833 9.29169 11.0833 9.00002C11.0833 8.70835 11.0729 8.4271 11.052 8.15627C11.0312 7.88544 11 7.61113 10.9583 7.33335H7.04163C6.99996 7.61113 6.96871 7.88544 6.94788 8.15627C6.92704 8.4271 6.91663 8.70835 6.91663 9.00002C6.91663 9.29169 6.92704 9.57294 6.94788 9.84377C6.96871 10.1146 6.99996 10.3889 7.04163 10.6667ZM12.625 10.6667H15.4583C15.5277 10.3889 15.5798 10.1146 15.6145 9.84377C15.6493 9.57294 15.6666 9.29169 15.6666 9.00002C15.6666 8.70835 15.6493 8.4271 15.6145 8.15627C15.5798 7.88544 15.5277 7.61113 15.4583 7.33335H12.625C12.6666 7.61113 12.6979 7.88544 12.7187 8.15627C12.7395 8.4271 12.75 8.70835 12.75 9.00002C12.75 9.29169 12.7395 9.57294 12.7187 9.84377C12.6979 10.1146 12.6666 10.3889 12.625 10.6667ZM12.2916 5.66669H14.75C14.3472 4.97224 13.8437 4.36808 13.2395 3.85419C12.6354 3.3403 11.9444 2.95835 11.1666 2.70835C11.4166 3.16669 11.6354 3.64238 11.8229 4.13544C12.0104 4.62849 12.1666 5.13891 12.2916 5.66669ZM7.41663 5.66669H10.5833C10.4166 5.05558 10.2013 4.47919 9.93746 3.93752C9.67357 3.39585 9.36107 2.87502 8.99996 2.37502C8.63885 2.87502 8.32635 3.39585 8.06246 3.93752C7.79857 4.47919 7.58329 5.05558 7.41663 5.66669ZM3.24996 5.66669H5.70829C5.83329 5.13891 5.98954 4.62849 6.17704 4.13544C6.36454 3.64238 6.58329 3.16669 6.83329 2.70835C6.05551 2.95835 5.36454 3.3403 4.76038 3.85419C4.15621 4.36808 3.65274 4.97224 3.24996 5.66669Z"
            />
          </svg>
          <span>Trending</span>
        </button>
        <draggable v-model="topicList" :key="topicList" class="draggable-list">
          <template v-slot:item="{ item }">
            <button
              :class="{ active: stateActiveTopicTab === item.interest.interest }"
              class="btn"
              @click="activeTopic(item)"
              @drop="onUpdate(item)"
            >
              <svg v-if="item.interest.is_private" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M220 976q-24.75 0-42.375-17.625T160 916V482q0-24.75 17.625-42.375T220 422h70v-96q0-78.85 55.606-134.425Q401.212 136 480.106 136T614.5 191.575Q670 247.15 670 326v96h70q24.75 0 42.375 17.625T800 482v434q0 24.75-17.625 42.375T740 976H220Zm260.168-200Q512 776 534.5 753.969T557 701q0-30-22.668-54.5t-54.5-24.5Q448 622 425.5 646.5t-22.5 55q0 30.5 22.668 52.5t54.5 22ZM350 422h260v-96q0-54.167-37.882-92.083-37.883-37.917-92-37.917Q426 196 388 233.917 350 271.833 350 326v96Z"/></svg>
              <svg v-else-if="!item.interest.is_private && item.interest.interest !== 'Your PDB'" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M480 976q-83 0-156-31.5T197 859q-54-54-85.5-127T80 576q0-83 31.5-156T197 293q54-54 127-85.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 83-31.5 156T763 859q-54 54-127 85.5T480 976Zm-43-61v-82q-35 0-59-26t-24-61v-44L149 497q-5 20-7 39.5t-2 39.5q0 130 84.5 227T437 915Zm294-108q22-24 38.5-51t28-56.5q11.5-29.5 17-60.5t5.5-63q0-106-58-192.5T607 257v18q0 35-24 61t-59 26h-87v87q0 17-13.5 28T393 488h-83v88h258q17 0 28 13t11 30v127h43q29 0 51 17t30 44Z"/></svg>
              <img v-else-if="!item.interest.is_private && item.interest.interest === 'Your PDB'" src="@/assets/icons/your-pdb.svg" />
              <span>{{ item.interest.interest }}</span>
              <a-dropdown
                @click.stop
                :trigger="['click']"
                placement="bottomRight"
              >
                <a class="ant-dropdown-link">
                  <i class="icon icon-vertical_three-dots"></i>
                </a>
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-if="allowedTopicManagementRoles.includes(item.permission) || !item?.interest.is_private" @click.prevent="showTopicManagmentDrawer(item)" key="0">
                      <a>Topic Management</a>
                    </a-menu-item >
                    <!-- <a-menu-item v-if="allowedAdminRequestAccessRoles.includes(item.permission) && item?.interest.is_private" @click.prevent="toggleRequestAccessModal(item)" key="0">
                      <a>Request Admin Access</a>
                    </a-menu-item > -->
                    <a-menu-item @click.stop="deleteTopic(item.interest.id)" key="1">
                      <a class="remove-btn">
                        Remove
                      </a>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </button>
          </template>
        </draggable>
      </div>
      <button class="add-topic-btn" @click.stop="addNewTopicDrawer()">
        <i class="icon icon-add_plus"></i>
        <span>Topic</span>
      </button>
    </div>
    <filters-pagination
      v-if="!visibleTopicDrawer"
    ></filters-pagination>
    

  </div>

  <!-- Topic Delete Modal -->
  <delete-modal
    :visible="visibleRemoveTopicModal"
    @handle-close="visibleRemoveTopicModal = false"
    title="Are you sure you want to remove this?"
    confirmText="Yes, Remove"
    cancelText="No, Don't Remove"
    :loading="onRemoveTopic"
    @delete-record="removeTopic"
  ></delete-modal>

  <!-- Topic Drawer  -->
  <add-new-topic-drawer
    :visibleTopicSideDrawer="visibleTopicDrawer"
    :updateTopicList="updateTopicList"
    :drawerPlacement="drawerPlacement"
    @closeTopicDrawer="closeAddTopicDrawer"
  >
  </add-new-topic-drawer>

  <!-- Topic Management Drawer  -->
  <topic-management-drawer
    :visibleDrawer="visibleTopicManagmentDrawer"
    :drawerPlacement="drawerPlacement"
    :topicToBeManage="topicToBeManage"
    @closeManagementDrawer="closeTopicManagementDrawer"
  >
  </topic-management-drawer>

  <requesta-news-source-drawer
    @closeRequestSourceDrawer=closeRequestSourcesDrawer()
    :visibleDrawer="visibleRequestNewsSourceDrawer"
    :type="requestType"
    :title="requestTitle"
  ></requesta-news-source-drawer>

<!-- Request Admin Access Modal -->
  <delete-modal
    :visible="isRequestAdminModalOpen"
    @handle-close="toggleRequestAccessModal()"
    title="Do you want to request admin access to this topic?"
    confirmText="Yes"
    cancelText="No"
    :loading="requestAdminAccessModalLoader"
    :invertButtonColors="true"
    @delete-record="requestAdminAccess"
  />
<!-- Request Admin Access Modal -->


<!-- Join Public Topic -->
  <delete-modal
  :visible="requestJoinPublicTopic"
  @handle-close="toggleRequestJoinPublicTopic()"
  :title='`Do you want to join the public topic \"${stateActiveTopicTab}\" ?`'
  confirmText="Yes"
  cancelText="No"
  :loading="requestJoinPublicTopicLoader"
  @delete-record="joinPublicTopic"
  :invertButtonColors="true"
  />
<!-- Join Public Topic -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DeleteModal from "../BaseComponents/DeleteModal.vue";
import Draggable from "vue3-draggable";
import AddNewTopicDrawer from "./AddNewTopicDrawer.vue";
import FiltersPagination from "./Filters&Pagination.vue";
import RequestaNewsSourceDrawer from "../BaseComponents/RequestaNewsSourceDrawer.vue";
import TopicManagementDrawer from "./TopicManagement/TopicManagementDrawer.vue";


export default {
  components: {
    DeleteModal,
    Draggable,
    AddNewTopicDrawer,
    FiltersPagination,
    RequestaNewsSourceDrawer,
    TopicManagementDrawer
  },
  data() {
    return {
      activeTopicTab: "",
      removeFields: false,
      isSubmit: false,
      visibleRemoveTopicModal: false,
      onRemoveTopic: false,
      topicToBeRemoved: "",
      showMessageModal: false,
      message: {},
      drawerPlacement: "",
      visibleTopicDrawer: false,
      updateTopicList:false,
      topicToBeUpdateOrder: "",
      activeNewsTab: true,
      visibleRequestNewsSourceDrawer: false,
      requestTitle: 'Request a source',
      requestType: 'news source',
      visibleTopicManagmentDrawer: false,
      topicToBeManage: {},
      allowedTopicManagementRoles: ['admin', 'editor', 'contributor'],
      allowedAdminRequestAccessRoles: ['editor', 'contributor'],
      isRequestAdminModalOpen: false,
      requestAdminAccessModalLoader: false,
      requestAdminAccessTopic: null,
      requestJoinPublicTopic: false,
      requestJoinPublicTopicLoader: false,

    };
  },
  watch: {
    // $route(to, _) {
    //   console.log(to,"This is watcher")
    //   // if(to.name == 'user-profile'){
      
    //   // }
    // },
    topicList:{
      handler(val) {
      if(this.topicToBeUpdateOrder){
        const order = val.findIndex((findItem) => findItem.id === this.topicToBeUpdateOrder );
        const newOrder = order + 1;
        this.updateOrdering(newOrder);
        this.topicToBeUpdateOrder = null
      }
      // when logged out user joins a topic
      if (this.$route.params?.id && Object.keys(this.topicDetails).length === 0){
        const topic = val.find(topic=> topic?.interest?.id === this.$route.params?.id)
        if (topic) {
          this.setActiveTopic(topic.interest.interest)
          this.activeTopicTab = topic.interest.interest;
          this.setTopicDetails(topic)
        }
      }
    }, immediate:true
  },
    $route:{
      handler(to, from){
        if (to.fullPath === '/discover'){
          if (Object.keys(this.topicDetails).length > 0){
              this.setTopicURL(this.topicDetails)
          }
        }else if (to.name === 'discoverTopicDetails'){
          const topicExists = this.topicList.find(topic=>topic?.interest?.id === this.topicDetails?.id || (typeof this.topicDetails.interest === 'object' && topic?.interest?.id === this.topicDetails?.interest?.id) )
          if (this.stateActiveTopicTab !== 'Trending news' && !topicExists)
            this.toggleRequestJoinPublicTopic()
          else if (this.stateActiveTopicTab === 'Trending news' && !topicExists){
            this.$router.push({name:'discover'})
          }
         
        }
      }, immediate: true
    },
  },
  computed: {
    ...mapGetters({
      stateActiveTopicTab: 'discover/activeTopicTab',
      discoverScrollPosition: 'discover/discoverScrollPosition',
    }),
    sortFilterValue() {
      const value = this.$store.getters["discover/getSortFilter"];

      if (value === "relevancy") {
        return "Relevant";
      } else if (value === "recency") {
        return "Date";
      } else {
        return "Sort"; // Default value when getter is empty or not "relevancy" or "recency"
      }
    },
    topicList: {
      get() {
        const topics = this.$store.getters["profile/topicsCategories"];
        const newTopics = this.removeDuplicateTopics(topics);
        return newTopics;
      },
      set(val) {
        this.$store.commit("profile/setUsersCategories", val);
      },
    },
    topicDetails() {
      return this.$store.getters["discover/getTopicDetails"];
    },
    getInterestGroupPrivateId() {
      const resp = this.$store.getters["article/getInterestGroup"];
       const foundElement = resp.find((element) => element.is_private);
      if (foundElement) {
          return foundElement.id;
        }
        return null
    },
    getInterestGroupPublicId() {
      const resp = this.$store.getters["article/getInterestGroup"];
       const foundElement = resp.find((element) => !element.is_private);
      if (foundElement) {
          return foundElement.id;
        }
        return null
    },
    topic(){
      return this.$store.getters['discover/getTopicRoute'] ? this.$store.getters['discover/getTopicRoute'].replace(/-/g, ' ') : "";
    },
    topicGroupId(){
      return this.$store.getters["article/getInterestGroupId"];
    },
    allNewsSources() {
      return this.$store.getters["discover/getSources"];
    },
  },
  async mounted() {
    this.topic === "" ? this.activeTopicTab = "Trending news" : this.activeTopicTab = this.topic;
    // if(this.activeTopicTab === 'Trending news') {
    //   this.$router.push('/discover')
    // }
    await this.emitter.on("openInvitedTopic", (val) => {
      this.searchTopicArticles(val.interest, val.id);
    });
    await this.emitter.on('close-create-topic-drawer', () => {
      this.closeRequestSourcesDrawer();
      this.$showToast({message:"Topic created successfully", type:'success'})
    });
    this.emitter.on("change-topic-type", (topic) => {
      const payload = {interest:{id:topic?.id}}
      this.getTopicGroupDetails(payload);
    });
    this.emitter.on("load-more-chats", () => {
      this.getChats();
    });
  },
  methods: {
    ...mapActions({
      getMessages: "aiChat/getMessages",
      setActiveSession: "aiChat/setActiveSession",
      emptySectionChats: "aiChat/emptySectionChats",
      toggleChatSectionSkeleton: "aiChat/toggleChatSectionSkeleton",
      emptyTopicPublicAndPrivateDiscussion : 'discussion/emptyTopicPublicAndPrivateDiscussion',
      setSelectedModule: 'discover/setSelectedModule',
      setActiveTopic: 'discover/setActiveTopic',
      sendAdminAccessRequest: 'discover/sendAdminAccessRequest',
      setDiscoverScrollPosition: 'discover/setDiscoverScrollPosition',
      // joinTopicThroughLink: 'discover/joinTopicThroughLink'
    }),
    onUpdate(newOrder){
      this.topicToBeUpdateOrder = newOrder.id;
    },
    async updateOrdering(order) {
      try {
        const payload = {
          order: order,
          id: this.topicToBeUpdateOrder
        }
        await this.$store.dispatch("profile/updateTopicsOrdering", payload);
      } catch (err) {
        console.log(err);
      }
    },
    closeSourceFilters(){
      this.emitter.emit("closeFilterBar");
    },
    setTopicURL(topic) {
      this.$store.commit("aiChat/CLEAR_SESSION_CHAT");
      if (topic) {
        this.setActiveTopic(topic.interest.interest)
        const cleanedTopicName = topic.interest.interest.trim();
        const sanitizedTopicName = cleanedTopicName.replace(/ /g, '-');
        const sanitizedTopicNameWithSlashes = sanitizedTopicName.replace(/\//g, '_');
        const routePath = `/discover/${sanitizedTopicNameWithSlashes}/${topic.interest.id}`;
        this.$router.push({ path: routePath });
        this.activeTopicTab = topic.interest.interest;
        this.setTopicDetails(topic)

      }
      else {
        this.setActiveTopic("Trending news")
        this.$router.push({ path: `/discover`});
        this.activeTopicTab = "Trending news";
        this.setTopicDetails()
      }
    },
    setTopicDetails(topic) {
      const searchedTopic = topic ? topic.interest.interest : "" ;
      this.$store.commit("discover/SET_SEARCHED_TOPIC", searchedTopic);
      this.$store.commit("discover/setSelectedTopic", topic);
      if (topic) {
        this.$store.commit('discover/SET_TOPIC_DETAILS', topic);
        this.setTopicNewsFilters(topic.interest)
        this.setTopicResearchFilters(topic.interest)
        this.getTopicGroupDetails(topic);
        this.searchTopicArticles(topic);
      } else {
        this.searchTopicArticles();
        this.$store.commit("article/setInterestGroup", []);
        this.$store.commit('discover/SET_TOPIC_DETAILS', {});
      }
    },
    async searchTopicArticles(topic) {
      const isAnySelectedSource = this.$store.getters['discover/getTopicSource'];
      if (topic) {
      if(topic.interest.sources_array.length > 0){
      this.$store.commit('discover/SET_FILTERS_COUNT', topic.interest.sources_array.length);
      this.$store.commit("discover/SET_TOPIC_SOURCE", true);
      this.$store.commit("discover/SET_INCLUDED_SOURCES", topic.interest.sources_array)
      const filteredNewsSources = this.allNewsSources.map((s) => {
          if(topic.interest.sources_array.findIndex(item=>item.key === s.key) < 0)
            return s
          }).filter(source=>source!==undefined)
      this.$store.commit("discover/SET_ALL_SOURCES", filteredNewsSources);
      } else if(topic.interest.sources_array.length === 0 && isAnySelectedSource){
        this.$store.commit("discover/SET_INCLUDED_SOURCES", [] )
      }
      }
      if (this.discoverScrollPosition === 0){
        this.$store.commit("discover/SET_INSIGHTS_PAGE_OFFSET", 0);
        this.$store.commit("discover/SET_ARTICLES_PAGE_OFFSET", 0);
      }

      this.searchNewsArticles();
      this.searchInsightsArticles();
    },
    async searchNewsArticles() {
      await this.$store.dispatch("discover/searchArticles");
    },
    async searchInsightsArticles() {
      await this.$store.dispatch("discover/searchInsights");
    },
    removeDuplicateTopics(topicList) {
      const uniqueTopics = {};
      topicList.forEach((topic) => {
        uniqueTopics[topic.id] = topic;
      });
      return Object.values(uniqueTopics);
    },
    async addNewTopicDrawer() {
      if (window.innerWidth < 576) {
        this.drawerPlacement = 'bottom'
      } else if (window.innerWidth > 576) {
        this.drawerPlacement = 'right'
      }
      this.fetchUserTopicList();
      this.updateTopicList = true
      this.visibleTopicDrawer = true;
    },
    async closeAddTopicDrawer(val) {
      this.visibleTopicDrawer = val;
    },
    async fetchUserTopicList() {
      try {
        await this.$store.dispatch("profile/getUserInterestList");
      } catch (err) {
        console.log(err);
      }
    },
    async getTopicGroupDetails(topic) {
      try {
        const payload = {
          interest_id: topic.interest.id,
        }
        const response = await this.$store.dispatch("article/topicGroupDetails", payload);
        if (response.status === 200) {
          this.$store.commit('discussion/SET_NEXT_URL', 1);
           this.$store.commit('discussion/SET_TOPICS_CHATS', []);
           this.emptyTopicPublicAndPrivateDiscussion()
          this.getDiscussionComments(topic);
          this.getChats(topic);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getChats(topic) {
      try {
        const payload = {
          interest_id: topic.interest.id,
          page: 1,
          page_size: 10
        }
        await this.$store.dispatch("discussion/fetchChattingMesssage", payload);
        const socketPayload = {
            interest_group: this.topicGroupId
          }
        this.$store.dispatch("discussion/connectChattingSocket", socketPayload);
      } catch (err) {
        console.log(err);
      }
    },
    async getDiscussionComments(topic){
        let payload = {
          interest_group_id: this.getInterestGroupPrivateId,
          interest_id: topic.interest.id,
          page: 1,
          page_size: 10,
          group: 'PRIVATE'
        }
          
          // // const payloadPrvt = {
        // //   interest_group_id: this.getInterestGroupPrivateId,
        // //   interest_id: topic.interest.id,
        // //   page: 1,
        // //   page_size: 10
        // // }
        // // const payloadPub = {
        // //   interest_group_id: this.getInterestGroupPublicId,
        // //   interest_id: topic.interest.id,
        // //   page: 1,
        // //   page_size: 10
        // // }
        // //fetching comments and users of private discussion
        // this.$store.dispatch('discussion/toggleDiscoverTopicCommentLoader')
        // await this.$store.dispatch("discussion/setDiscussionComments", payload );
        // // await this.$store.dispatch("discussion/fetchDiscussionUsers", payload)
        // if(!topic.interest.is_private){
        //   payload.interest_group_id = this.getInterestGroupPublicId,
        //   payload.group = 'PUBLIC'
        //   // fetching comments and users of public discusssions 
        //   await this.$store.dispatch("discussion/setDiscussionComments", payload);
        //   // await this.$store.dispatch("discussion/fetchDiscussionUsers", payload)
        // }
        // this.$store.dispatch('discussion/toggleDiscoverTopicCommentLoader')
        // // if(topic.interest.is_private){
        // //     await this.$store.dispatch("discussion/setPrivateDiscussionComments", payloadPrvt );
        // // }else{
        // //     await this.$store.dispatch("discussion/setPrivateDiscussionComments", payloadPrvt );
        // //     await this.$store.dispatch("discussion/setPublicDiscussionComments", payloadPub );
        // // }
        // payload = {
        //     interest_group: this.topicGroupId,
        //     isPrivate: topic.interest.is_private
        //   }
        // this.$store.dispatch("discussion/connectDiscussionSocket", payload);
        // this.emitter.emit('stop-load-chats', false);
    },
    showTopicManagmentDrawer(topic) {
      // if (this.activeTopicTab  !== topic?.interest?.interest){
        this.setTopicURL(topic)
      // }

      this.topicToBeManage = {
          id: topic?.interest?.id,
          name: topic?.interest?.interest,
          is_private: topic?.interest?.is_private ?? false,
          ...topic
      }
      if (window.innerWidth < 576) {
        this.drawerPlacement = 'bottom'
      } else if (window.innerWidth > 576) {
        this.drawerPlacement = 'right'
      }
      this.visibleTopicManagmentDrawer = true;
    },
    closeTopicManagementDrawer() {
      this.visibleTopicManagmentDrawer = false;
    },
    async deleteTopic(id) {
      this.topicToBeRemoved = id;
      this.visibleRemoveTopicModal = true;
      this.removeFields= await true
      this.removeFields= await false
    },
    async removeTopic() {
      this.onRemoveTopic = true;
      const response = await this.$store.dispatch('profile/deleteCategory', this.topicToBeRemoved);
      if(response.status == 204){
        const updatedTopicList = this.topicList.filter((val) => {
            return val.interest.id !== this.topicToBeRemoved;
        });
        this.showMessageModal = true;
        this.message = {
          title: "Topic removed successfully.",
          type: "success",
        };
        this.topicList = updatedTopicList;
        this.onRemoveTopic = false;
        this.visibleRemoveTopicModal = false;
        if(this.activeTopicTab !== "Trending news"){
        this.$router.push({ path: `/discover`});
        this.activeTopicTab = "Trending news";
        this.setTopicDetails()
        }
      }
    },
    activeTabs(tab){
      if(tab === 'news-tab'){
        this.activeNewsTab = true;
        this.requestTitle = 'Request a source';
        this.requestType = 'news source'
        this.emitter.emit('showNewsTab', 'news-tab');
        this.setSelectedModule(tab)
      }else {
        this.activeNewsTab = false;
        this.requestTitle = 'Request an insight source';
        this.requestType = 'insight source'
        this.emitter.emit('showNewsTab', 'insight-tab');
        this.setSelectedModule(tab)
      }
      
    },
    showRequestSourceDrawer() {
      this.visibleRequestNewsSourceDrawer = true
    },
    closeRequestSourcesDrawer() {
      this.visibleRequestNewsSourceDrawer = false
    },
    showSortDrawer() {
      this.emitter.emit("show-sort-drawer");
    },
    openSourcesDrawer() {
      this.emitter.emit("show-sources-drawer");
    },
    setTopicNewsFilters(topicInterest){
      this.$store.commit("discover/SET_INCLUDED_SOURCES", topicInterest?.news_filter?.included_sources ?? [])
      this.$store.commit("discover/SET_EXCLUDED_SOURCES", topicInterest?.news_filter?.excluded_sources ?? [])
      this.$store.commit("discover/SET_START_DATE", topicInterest?.news_filter?.date_range?.lower ?? '');
      this.$store.commit("discover/SET_END_DATE", topicInterest?.news_filter?.date_range?.upper ?? '');
      this.$store.commit('discover/PDB_INCLUDED_KEYWORDS', topicInterest?.news_filter?.included_keywords ?? []);
      this.$store.commit('discover/PDB_EXCLUDED_KEYWORDS', topicInterest?.news_filter?.excluded_keywords ?? []);
      this.$store.dispatch('discover/setPDBExactKeyWord', topicInterest?.news_filter?.exact_match ?? '');

    },
    setTopicResearchFilters(topicInterest){
      this.$store.commit("discover/SET_INSIGHTS_INCLUDED_SOURCES", topicInterest?.research_filter?.included_sources ?? [])
      this.$store.commit("discover/SET_INSIGHTS_EXCLUDED_SOURCES", topicInterest?.research_filter?.excluded_sources ?? [])
      this.$store.commit("discover/SET_INSIGHTS_START_DATE", topicInterest?.research_filter?.date_range?.lower ?? '');
      this.$store.commit("discover/SET_INSIGHTS_END_DATE", topicInterest?.research_filter?.date_range?.upper ?? '');
      this.$store.commit('discover/INSIGHTS_INCLUDED_KEYWORDS', topicInterest?.research_filter?.included_keywords ?? []);
      this.$store.commit('discover/INSIGHTS_EXCLUDED_KEYWORDS', topicInterest?.research_filter?.excluded_keywords ?? []);
      this.$store.dispatch('discover/setInsightsExactKeyWord', topicInterest?.research_filter?.exact_match ?? '');

    },
    toggleRequestAccessModal(topic=null){
      if (topic)
        this.requestAdminAccessTopic = topic
      this.isRequestAdminModalOpen =!this.isRequestAdminModalOpen
    },
    toggleRequestJoinPublicTopic(){
      // if (topic)
      //   this.requestAdminAccessTopic = topic
      // console.log(this.requestJoinPublicTopic, "REQUEST")
      this.requestJoinPublicTopic = !this.requestJoinPublicTopic
    },
    async requestAdminAccess(){
      try{
        console.log("TOPIC", this.requestAdminAccessTopic)
        await this.sendAdminAccessRequest({topicId: this.requestAdminAccess?.id})
        this.$showToast({message:'Request has been sent to admin.', type:'success'})
      }
      catch(err){
        this.$showToast({message:'Something went wrong. Please try again later.', type:'failure'})
      }
    },
    async joinPublicTopic(){
      try{
        this.requestJoinPublicTopicLoader = true
        const payload = {
              interest: this.topicDetails?.interest,
              is_private: false,
        }
        const res = await this.$store.dispatch(
            "profile/craeteNewInterest",
            [payload]
        );
        this.$store.commit('discover/SET_TOPIC_DETAILS', res.data);
        await this.$store.dispatch("profile/getUserTopicsWithOrdering");
        this.$showToast({message:'Topic joined successfully.', type:'success'})
      }
    catch(err){ 
      console.log("ERR", err.response.data)
      if (err?.response?.data[0]?.error[0].includes("You've already created a public topic with this name in your tab.")){
        this.$showToast({message:'You have already joined this topic', type:'failure'})
      }
      this.$showToast({message:'Something went wrong. Please try again later', type:'failure'})
    }finally{
      this.requestJoinPublicTopicLoader = false
      this.toggleRequestJoinPublicTopic()
    }
    },
    activeTopic(topic){
      this.setDiscoverScrollPosition(0)
      this.setTopicURL(topic)
    }
  },
};
</script>

<style lang="scss">
.discover-topics-apply-filter {
  position: sticky;
  z-index: 111;
  top: 7.8rem;
  background-color: $color-white;
  box-shadow: rgba(33, 35, 38, 0.128) 0px 10px 10px -10px;
  @include respond(phone-x-small) {
    top: 10.8rem;
    position: fixed;
    width: 100%;
    z-index: 112;
  }
  &__tabs-container {
    display: none;
    @include respond(phone-x-small) {
      display: flex;
      border-bottom: 1px solid #cdcdcd;
      align-items: center;
      padding: 2.4rem 3rem;
      justify-content: space-between;
    }
    &--tabs {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      overflow: hidden;
      width: fit-content;
      margin-right: 1rem;
      .btn {
        line-height: 2rem;
        font-family: $font-primary;
        background-color: $color-white;
        font-size: 2rem;
        padding: 0 3rem;
        height: 5rem;
        border-radius: 100px !important;
        border: 1px solid #cdcdcd;
        outline: none;
        cursor: pointer;
        color: #434343 !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: fit-content;
        position: relative;
        z-index: 2;
        @media (max-width: 400px) {
          font-size: 1.6rem;
          padding: 0 3rem;
          height: 4.5rem;
        }
      }
      .tabs-two {
        margin-left: -6rem;
        margin-right: 0;
        position: relative;
        z-index: 1;
        padding-left: 7rem;
      }
      .active {
        background-color: $color-primary;
        border-color: $color-primary;
        color: $color-white !important;
        font-family: $font-primary-medium;
      }
    }
    &--tabs::-webkit-scrollbar {
      display: none;
    }
    &--buttons {
      display: flex;
      align-items: center;
      .sort-container {
        position: relative;
        margin: 0 1rem;
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100px !important;
        border: none;
        outline: none;
        background-color: #ebebeb;
        cursor: pointer;
        height: 4.9rem;
        width: 8rem;
        img {
          width: 2rem;
          height: auto;
        }
        svg {
          width: 2rem;
          height: auto;
        }
        .request-icon {
          width: 3rem;
          height: auto;
        }
      }
      @media (max-width: 360px) {
        .btn {
          height: 4.8rem;
          width: 7rem;
          img {
            width: 1.8rem;
            height: auto;
          }
          svg {
            width: 1.8rem;
            height: auto;
          }
          .request-icon {
            width: 2.8rem;
            height: auto;
          }
        }
      }
    }
  }
  &__topics {
    padding: 2rem 1rem 0;
    margin: 0 1rem 0;
    display: flex;
    align-items: center;
    width: auto;
    @include respond(laptop-large) {
      padding-top: 2rem;
    }
    @include respond(phone-x-small) {
      padding: 2.4rem 1rem 0;
      margin: 0 2rem 0;
    }
    &--all-tabs-btn {
      width: max-content;
      display: flex;
      align-items: center;
      overflow-x: auto;
      overflow-y: hidden;
      .draggable-list {
        display: flex;
        align-items: center;
      }
    }
    &--all-tabs-btn::-webkit-scrollbar {
      height: 0.4rem;
    }

    &--all-tabs-btn::-webkit-scrollbar-track {
      background-color: #c8c8c87d;
      border-radius: 0.8rem;
      height: 0.4rem;
    }

    &--all-tabs-btn::-webkit-scrollbar-thumb {
      background-color: $color-primary;
      border-radius: 0.8rem;
    }
    .btn {
      display: flex;
      align-items: center;
      height: 3.8rem;
      padding: 0 1.3rem;
      border-top-right-radius: 1rem !important;
      border-top-left-radius: 1rem !important;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      margin-right: 1rem;
      border: none;
      outline: none;
      cursor: pointer;
      font-family: $font-primary-medium;
      background-color: #ebebeb;
      font-size: 1.6rem;
      color: #434343;
      line-height: 2rem;
      width: max-content;
      @include respond(phone-x-small) {
        height: 5.8rem;
        padding: 0 2rem;
        font-size: 2rem;
      }
      
      .icon {
        cursor: pointer;
        font-size: 1.2rem;
        color: $color-black;
        margin-left: 0.5rem;
        @include respond(phone-x-small) {
          font-size: 2rem;
        }
      }
      .icon-add_plus {
        transform: rotate(45deg);
        margin-left: 1rem;
        @include respond(phone-x-small) {
          margin-left: 1.5rem;
        }
      }
      svg {
        width: 1.7rem;
        height: auto;
        margin-right: 0.8rem;
        fill: #434343;
        @include respond(phone-x-small) {
          width: 2.4rem;
          height: auto;
        }
      }
      img {
        width: 2.4rem;
        height: auto;
        margin-right: 0.8rem;
        object-fit: contain;
        filter: invert(0);
        @include respond(phone-x-small) {
          width: 3rem;
          height: auto;
        }
      }
      span {
        display: block;
        width: max-content;
        line-height: normal;
      }
    }
    .default-btn{
      cursor:pointer;
      display: flex;
      @include respond(phone-x-small) {
        display: none;
      }
    }
    .mobile-btn-default {
      display: none;
      @include respond(phone-x-small) {
        display: flex;
      }
    }
    .active {
      background-color: $color-primary;
      color: $color-white;
      svg {
        fill: $color-white;
      }
      .icon {
        color: $color-white;
      }
      img {
        filter: invert(1);
      }
    }
    .add-topic-btn {
      background-color: transparent;
      border: none;
      outline: none;
      display: flex;
      align-items: center;
      font-family: $font-primary-medium;
      font-size: 1.6rem;
      color: #434343;
      cursor: pointer;
      margin-left: 1rem;
      line-height: normal;
      @include respond(tab-port) {
        margin-right: 1rem;
      }
      @include respond(phone-x-small) {
        margin-left: 1.3rem;
        font-size: 2rem;
        margin-right: 0;
      }
      .icon {
        cursor: pointer;
        font-size: 1.6rem;
        margin-right: 0.9rem;
        line-height: normal;
        @include respond(phone-x-small) {
          font-size: 1.8rem;
        }
      }
    }
    // .add-topic-btn-mobile {
    //   display: none;
    //   @include respond(tab-port) {
    //     display: flex;
    //   }
    // }
  }
  .apply-filter {
    display: flex;
    @include respond(phone-x-small) {
      display: none;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.sort-drawer {
  .ant-drawer-content-wrapper {
    height: 26.9rem !important;
    .ant-drawer-content {
      .ant-drawer-wrapper-body {
        .ant-drawer-body {
          height: 100%;
          padding: 3.6rem 3.2rem;
          .sort-drawer-container {
            height: 100%;
            &__header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 5.2rem;
              p {
                font-size: 3.1rem;
                font-family: $font-primary-bold;
                line-height: normal;
                margin-bottom: 0;
              }
              .icon {
                display: block;
                transform: rotate(45deg);
                cursor: pointer;
                font-size: 2.5rem;
                opacity: 1;
                color: $color-black;
              }
            }
            &__body {
              button {
                display: block;
                font-size: 2.2rem;
                font-family: $font-primary;
                line-height: normal;
                border: none;
                outline: none;
                background-color: transparent;
                cursor: pointer;
                &:first-child {
                  margin-bottom: 5.2rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
